import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }


import editModal from './components/editModal.vue'
import Modal from '@/hooks/modalType'
import { reactive, ref, computed } from 'vue'
import { biLoseWarningList, deleteBiLoseWarning } from '@/api/gucangSales/businessRuleSetting'

import { DcMessage } from '@dc-platform/dc-components'
import { BigScoreBakcData } from '@/typings/api/gucangSale'
import ButtonWrapperTips from '@/components/ButtonWrapperTips/index.vue'
const __default__ = { name: 'DcCosFbuLossWarning' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

// eslint-disable-next-line func-call-spacing
const editModalRef = ref<{ toggle: (row?: BigScoreBakcData) => void }>()

const tableRef = ref()
const queryForm = reactive({
  arkCode: '',
  customerName: ''
})

// 获取列表
const fetch = async (params: object, callBack: (res: any) => void) => {
  const res = await biLoseWarningList({ ...params })
  callBack(res)
}
const success = () => {
  tableRef.value.fetch()
}
const columns = computed(() => [
  { title: '客户名称', dataIndex: 'customerName' },
  { title: '子客户代码', dataIndex: 'arkCode' },
  { title: '风险程度 ', dataIndex: 'riskLevel' },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right'
  }
])
const addEdit = (_row?: BigScoreBakcData) => {
  editModalRef.value?.toggle(_row)
}
const deleteRow = (row: BigScoreBakcData) => {
  Modal.delete({
    name: row.customerName,
    onOk() {
      deleteBiLoseWarning(row.id).then(() => {
        DcMessage.success('删除成功')
        tableRef.value?.delFetch()
      })
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_more_button = _resolveComponent("more-button")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            serial: "",
            columns: columns.value,
            onFetch: fetch,
            search: queryForm,
            "onUpdate:search": _cache[3] || (_cache[3] = ($event: any) => ((queryForm) = $event)),
            ref_key: "tableRef",
            ref: tableRef,
            tableId: "DcCosLossWarning"
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: queryForm }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, {
                    name: "customerName",
                    label: "客户名称"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.customerName,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.customerName) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "arkCode",
                    label: "子客户代码"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.arkCode,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.arkCode) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            bodyCell: _withCtx(({ column, record }) => [
              (column.dataIndex === 'riskLevel')
                ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(['低', '中', '高'][record.riskLevel - 1] || '--'), 1))
                : _createCommentVNode("", true),
              (column.dataIndex === 'action')
                ? (_openBlock(), _createBlock(_component_more_button, { key: 1 }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (addEdit(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("编辑")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'fbu_losswarning_edit_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (deleteRow(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("删除")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'fbu_losswarning_delete_btn']
                      ])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            button: _withCtx(() => [
              _createVNode(ButtonWrapperTips, { text: "该客户流失等级数据来源于BI" }, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                    type: "primary",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (addEdit()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("新增")
                    ]),
                    _: 1
                  })), [
                    [_directive_permission, 'fbu_losswarning_add_btn']
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["columns", "search"]),
          _createVNode(editModal, {
            ref_key: "editModalRef",
            ref: editModalRef,
            onSuccess: success
          }, null, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})